import React from "react";
import { ShieldCheck } from "lucide-react";
import {
  FlowLogo,
  MercadoPagoLogo,
  WebpayLogo,
  VisaLogo,
  MastercardLogo,
} from "./PaymentBrandLogos";

/**
 * TrustBar
 *
 * Discreet horizontal strip showcasing supported payment methods.
 * Sits above the plans section to reduce purchase friction.
 *
 * Layout:
 *   [🛡 icon]  "Pago seguro con:"   [Flow] [MP] [Webpay] [Visa] [MC]
 *
 * The whole strip is muted (no heavy backgrounds, just a soft card)
 * so it doesn't compete with the plan cards below it.
 */
export default function TrustBar() {
  const logos = [
    { Logo: FlowLogo, label: "Flow.cl" },
    { Logo: MercadoPagoLogo, label: "Mercado Pago" },
    { Logo: WebpayLogo, label: "Webpay" },
    { Logo: VisaLogo, label: "Visa" },
    { Logo: MastercardLogo, label: "Mastercard" },
  ];

  return (
    <div
      data-testid="trust-bar"
      className="max-w-3xl mx-auto mb-8"
      style={{
        background: "rgba(255,255,255,0.02)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        border: "1px solid var(--pl-border)",
        borderRadius: 14,
        padding: "12px 18px",
      }}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-2 shrink-0">
          <ShieldCheck
            className="w-4 h-4"
            style={{ color: "var(--pl-primary)" }}
            strokeWidth={2.4}
          />
          <span
            className="text-xs font-semibold tracking-wide uppercase"
            style={{ color: "var(--pl-text-muted, #64748b)", letterSpacing: "0.08em" }}
          >
            Pago seguro con
          </span>
        </div>

        <div
          className="flex flex-wrap items-center gap-2.5 sm:gap-3 justify-center sm:justify-end"
          aria-label="Métodos de pago soportados"
        >
          {logos.map(({ Logo, label }) => (
            <div
              key={label}
              data-testid={`trust-bar-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              title={label}
              style={{
                display: "flex",
                alignItems: "center",
                opacity: 0.95,
                transition: "opacity 0.15s ease, transform 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = "1";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = "0.95";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <Logo size={22} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
